import '../App.css';

function About() {
  return (
    <header className="App-header relative">
      <div className="container mx-auto px-4">
        <h1>About Us</h1>
        <div className="bg-white/10 backdrop-blur-md rounded-2xl p-8 shadow-lg max-w-2xl mx-auto mt-8 border border-white/20">
          <p className="text-xl leading-relaxed mb-8 text-center">
            Hubble Heavy Industries Inc. is in the process of taking over the entire world
          </p>
          <div className="text-xl space-y-4 flex flex-col items-center">
            <a 
              href="https://www.climatechinnovations.com/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="hover:text-blue-300 transition-colors"
            >
              Climatech Innovations Inc.
            </a>
            <a 
              href="https://norumbegalands.ca/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="hover:text-blue-300 transition-colors"
            >
              Norumbega Lands Inc.
            </a>
            <span className="text-white/70">
              Outseek Enterprises Ltd.
            </span>
            <span className="text-white/70">
              Distilligen Inc.
            </span>
          </div>
        </div>
      </div>
    </header>

  );
}

export default About; 